<template>
  <div class="grade-main" v-show="userId != null">
    <div class="grade-main-head">
      <div>当前积分: {{ grade }}</div>
      <div class="grade-main-rate">
        <el-rate
          v-model="grade_"
          disabled
          show-text
          :texts="rules.texts"
          :max="rules.max"
          text-color="#ff9900"
        ></el-rate>
      </div>
    </div>
    <div
      class="grade-main-time"
      :style="'height:' + (this.mainHeight ? this.mainHeight : (this.$tools.mainHeight() - 120)) + 'px'" v-infinite-scroll="next" :infinite-scroll-disabled="disabled()" infinite-scroll-delay=1000
    >
      <el-timeline>
        <el-timeline-item
          v-for="(change, index) in records"
          :key="index"
          :timestamp="change.creatorName + ' 提交于 ' + $tools.timestampToTime(change.createTime)"
          placement="top"
        >
          <div class="grade-card">
            <el-card shadow="always">
              <div slot="header">
                <el-row>
                  <el-col :span="8">
                    <span class="grade-card-change" v-if="change.changeGrade > 0">变动分数:+{{change.changeGrade}}</span>
                    <span class="grade-card-change-red" v-if="change.changeGrade < 0">变动分数:{{change.changeGrade}}</span>
                  </el-col>
                  <el-col :span="8" style="text-align: center;">
                    <span class="grade-card-date" v-if="change.type == 'a'">考核月份:{{ $tools.timestampToMonth(change.applyMonth)}}</span>
                    <span class="grade-card-date" v-else>/</span>
                  </el-col>
                  <el-col :span="8">
                      <span class="grade-card-totle grade-card-totle-red" v-if="change.status == 'N' || change.status == 'F' ">状态:{{change.status == 'N' ? '驳回': '驳回'}}</span>
                      <span class="grade-card-totle" v-if="change.status == 'Y' || change.status == 'W' ">状态:{{change.status == 'Y' ? '生效': '等待审核'}}</span>
                  </el-col>
                </el-row>
              </div>

               <el-row>
                 <el-col :span="8">样板单加分：{{change.simpleNumber ? change.simpleNumber * 0.5: 0}}</el-col>
                 <el-col :span="8">订单加分1：{{change.orderNumber ? change.orderNumber * 2 : 0}}</el-col>
                 <el-col :span="8">订单加分2：{{change.bigOrderNumber ? change.bigOrderNumber * 3 : 0}}</el-col>
               </el-row>

               
               <el-row>
                 <el-col :span="8">业绩加分：{{getAmountChange(change.amount, change.avgAmount)}}</el-col>
                 <el-col :span="8">业绩：{{$tools.parsecost(change.amount)}}</el-col>
                 <el-col :span="8">平均：{{$tools.parsecost(change.avgAmount)}}</el-col>
               </el-row>
              
              <el-row>
                其他变动分： {{change.otherGrade}}
              </el-row>
               <el-row>
                  <el-input
                    v-model="change.remark"
                    autocomplete="off"
                    type="textarea"
                    rows="5"
                    grade-card-remark disabled
                    style="margin-top:10px;"
                  ></el-input>
               </el-row>

            </el-card>
          </div>
        </el-timeline-item>

        <p v-if="!disabled()">加载中....</p>
        <p v-if="disabled()">没有更多了...</p>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserGradeDetail",
  props: {
    userId: Number,
    mainHeight: '',
  },
  data() {
    return {
      rules: {
        max: 9,
        texts: this.$tools.levelTexts,
      },
      grade: -1,
      grade_: 0,
      page: {},
      records: [],
    };
  },
  methods: {
    disabled() {
      return this.page.current >= this.page.pages || this.page.total == 0;
    },
    next() {
        this.page.current = this.page.current + 1
        this.searchGrade(this.userId);
    },
    searchGrade(userId, page) {
      let _this = this;

      if (page) {
        _this.page = page;
        _this.grade = -1;
        _this.records = [];
      }

      if (userId == null) {
        _this.records = [];
        _this.setGrade(0);
        return;
      }


      let urlGet = userId == 'self' ? "user/grade/getGradeSelf" : "user/grade/getGrade";

      if (_this.grade == -1) {
        _this.$http.post(
          [urlGet, userId],
          [
            function (grade) {
              _this.setGrade(grade);
            },
          ], "none"
        );
      }

      let urlPage =  userId == 'self' ?  "/user/grade/pageSelf" : "/user/grade/page";

      _this.$http.post(
        [urlPage, _this.page, { userId: _this.userId }],
        [
          function (page) {
            _this.page = page;
            _this.records= _this.records.concat(page.records);
          },
        ], "none"
      );
    },
    setGrade(grade) {
      this.grade = grade;

      if (this.grade > 800) {
        this.grade_ = this.rules.max;
      } else {
        this.grade_ = parseFloat(this.grade / 100);
      }
    },
    getAmountChange(amount, avgAmount) {
      amount = amount ? amount : 0;
      avgAmount = avgAmount ? avgAmount : 0;

      return Math.round((amount - avgAmount) / 100000)
    }
  },
  watch: {
    userId(val) {
      this.grade = -1
      this.page = {}
      this.records = []
      
      this.searchGrade(val);
    },
  },
};
</script>

<style scoped>
.grade-main {
  margin-left: 10px;
}
.grade-main-head {
  height: 30px;
}
.grade-main-head > div {
  float: left;
}
.grade-main-rate {
  width: 300px;
  margin-left: 10px;
}
.grade-main-time {
  overflow-x: hidden;
}
.grade-card {
  width: 500px;
}
.grade-card-remark {
  height: 150px;
}
.grade-card-totle {
  color: #409eff;
  float: right;
}
.grade-card-date {
   color: #E6A23C;
}

.grade-card-totle-red {
  color: #F56C6C;
}
.grade-card-change {
  color: #67C23A;
}
.grade-card-change-red {
  color: #F56C6C;
}
</style>